import styled from 'styled-components'

const SavingsWrapper = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: ${({ theme }) => theme.responsive.mobile};
  .card-title {
    margin-left: 15px;
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: ${({ theme }) => theme.colors.white};
      margin-top: 30px;
    }
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 36px;
      color: ${({ theme }) => theme.colors.white};
      margin-top: -20px;
    }
  }
  .saving-card {
    width: 320px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.secondPrimary};
    border-radius: 14px;
    color: white;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
  }
  .savings-btn-container {
    width: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .btn-container {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    .savings-btn-container {
      display: flex;
      justify-content: space-between;
      padding: 0px 7px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        padding: 0px 7px;
      }
    }

    .btn-container {
      display: none;
    }
  }

  .savings-carousel {
    width: 100vw;
  }

  .rec.rec-dot {
    display: none;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: block;
      width: 5px;
      height: 5px;
      background: #6e7191;
    }
  }
  .rec.rec-dot.rec-dot_active {
    width: 22px;
    height: 5px;
    background: #2336ff;
    border-radius: 10px;
    border: none;
  }

  .card-number {
    width: 100%;
    text-align: center;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -20px;
    }
  }

  .card-number p {
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 34px;
    margin-bottom: 20px;
  }

  h2 {
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.navyBlue};

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.x2};
    }
  }

  .general {
    color: ${({ theme }) => theme.colors.Gprimary};
  }

  .target {
    color: ${({ theme }) => theme.colors.successGreen};
  }
  .links {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .black {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #4f4f4f;
  }

  .emergency {
    color: ${({ theme }) => theme.colors.Emergency};
  }

  .saving-link {
    text-decoration: none;
    color: inherit;
    width: 100vw;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
  }
`

const SavingsCardWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    flex-direction: column;
    justify-content: center;
  }

  .card-one {
    width: 70%;
    @media (min-width: ${({ theme }) =>
        theme.responsive.ipad}) and (max-width: 1000px) {
      width: 60%;
    }
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 100% !important;
    }
  }

  .card-two {
    width: 30%;
    margin-top: -30px;
    @media (min-width: ${({ theme }) =>
        theme.responsive.ipad}) and (max-width: 1000px) {
      width: 40%;
    }
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 50%;
      text-align: center;
    }
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 60% !important;
    }
    @media (max-width: 380px) {
      width: 80% !important;
    }
    .bottom {
      margin-bottom: 18px;
    }

    .money {
      border-radius: 10px;
      height: 180px;
      width: 100%;
      margin-right: 90px;

      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        height: 180px;
        width: 100%;
        margin-right: 0px;
      }
    }
  }

  .amount {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .amount h2 {
    font-weight: 700;
    font-size: ${({ theme }) => theme.fontSize.xxl};
    line-height: 34px;
    @media (min-width: ${({ theme }) =>
        theme.responsive.ipad}) and (max-width: 850px) {
      font-size: ${({ theme }) => theme.fontSize.xl};
    }
    @media (max-width: 380px) {
      font-size: ${({ theme }) => theme.fontSize.xl};
    }
  }
  .card-title {
    margin-left: 715px;
  }
  .card-title p {
    font-size: ${({ theme }) => theme.fontSize.x2};
    font-family: ${({ theme }) => theme.fontFamily.inter};
    line-height: 26px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.white};
  }

  .increase-icon {
    margin-left: 10px;
  }

  .card-two p {
    color: #6e7191;
    font-size: ${({ theme }) => theme.fontFamily.x2};
    margin: 0;
    text-align: center;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 2rem 0;

    .card-one {
      width: 90%;
    }

    .card-two {
      width: 80%;
    }
  }
`

const SavingsCardLink = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 0;
  /* overflow:hidden; */
`

export { SavingsWrapper, SavingsCardWrapper, SavingsCardLink }
